import { IResourceComponentsProps } from "@refinedev/core";
import { Edit, useForm } from "@refinedev/antd";
import { Form, Button } from "antd";

import { FormList } from "./form";
import { IOrder } from "interfaces";

export const OrderEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IOrder>();
  return (
    <Edit
      isLoading={queryResult?.isFetching}
      saveButtonProps={saveButtonProps}
      headerButtons={<Button onClick={() => history.back()}>Back</Button>}
    >
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          isActive: true,
          ...formProps.initialValues,
        }}
      >
        <FormList formProps={formProps} type="edit" />
      </Form>
    </Edit>
  );
};
